import { IconButton, Link, Stack, TableCell, TableRow, Tooltip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { JIRA_BROWSE_URL, toPercent } from "plugins/toolbox/constants"
import { QuickWinMatch } from "./quick-win-match"

export function QuickWinRow({ item }) {
    const bestCloseness = `${toPercent(item.bestCloseness)}`

    return (
        <TableRow hover>
            <TableCell>
                <Stack direction="row" spacing={0.5} alignItems="center">
                    <Link href={`${JIRA_BROWSE_URL}/${item.key}`} target="_blank" rel="noopener noreferrer">
                        {item.key}
                    </Link>
                    <Tooltip title={<Repeat list={item.matches} item={<QuickWinMatch />} />} arrow placement="right">
                        <IconButton size="small">
                            <Iconify icon="mdi:information-outline" width="18px" height="18px" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </TableCell>
            <TableCell>
                <TruncatedTypography variant="body2">{item.summary}</TruncatedTypography>
            </TableCell>
            <TableCell>{item.status}</TableCell>
            <TableCell align="right">{bestCloseness}</TableCell>
        </TableRow>
    )
}
